import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import Button from "@mui/material/Button";
import { fnGetDataSet } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";
import SnSearchBtn from "@shared/components/SnSearchBtn";

interface popupProps {
  selectedData?: any;
  modalRef?: any;
}

const SN_PUR_RCV_REG_001_POP_001 = forwardRef(
  ({ selectedData, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    const gridRef1 = useRef<any>(null);
    const gridRef2 = useRef<any>(null);
    const gridRef3 = useRef<any>(null);
    const gridRef4 = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);

    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);
    const [columns3, setColums3] = useState<any[]>([]);
    const [columns4, setColums4] = useState<any[]>([]);

    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);
    const [dataSource3, setDataSource3] = useState<any[]>([]);
    const [dataSource4, setDataSource4] = useState<any[]>([]);

    const [gridFocus, setGridFocus] = useState(false);
    const selectedTabPage = useRef<string>("1");
    const isSyncingCheckbox = useRef(false);
    //#endregion

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        let isSame: boolean = false;

        const selectedHeader =
          selectedTabPage.current === "1"
            ? gridRef1.current?.getCheckedRows()
            : gridRef3.current?.getCheckedRows();

        if (selectedHeader && selectedHeader.length > 0) {
          const cdCustValue = selectedHeader[0].cd_cust; // 거래처
          const cdExchValue = selectedHeader[0].cd_exch; // 환종
          const rtExchValue = selectedHeader[0].rt_exch; // 환율

          isSame = selectedHeader.every(
            (item: any) =>
              item.cd_cust === cdCustValue &&
              item.cd_exch === cdExchValue &&
              item.rt_exch === rtExchValue
          );
        } else {
          return { flag: true };
        }

        if (!isSame) {
          return {
            flag: false,
            message: "거래처, 환종, 환율 정보가 동일한 건만 적용 가능합니다.",
          };
        } else {
          return { flag: true };
        }
      },

      getSelectedRow: () =>
        selectedTabPage.current === "1"
          ? [
              gridRef1.current.getCheckedRows() || [],
              gridRef2.current.getCheckedRows() || [],
            ]
          : [
              gridRef3.current.getCheckedRows() || [],
              gridRef4.current.getCheckedRows() || [],
            ],
    }));

    useEffect(() => {
      if (selectedTabPage.current === "1") {
        gridRef1.current.selectAndFocusRow(0);
        setGridFocus(false);
      } else {
        gridRef3.current.selectAndFocusRow(0);
        setGridFocus(false);
      }
    }, [gridFocus]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_PUR_RCV_REG_001_POP_001", {});
          const mergedData: any = { ...rtn.formData, ...selectedData };
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setFormData(mergedData); // 조회조건 초기값
          setColums1(rtn.grid.grid1); // H그리드 항목 설정
          setColums2(rtn.grid.grid2); // L그리드 항목 설정
          setColums3(rtn.grid.grid3);
          setColums4(rtn.grid.grid4);
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const param = {
            id: "sn_pur_rcv_reg_001_pop_01",
            params: searchRef.current.getFormdata(),
          };

          setDataSource1([]);
          setDataSource2([]);
          setDataSource3([]);
          setDataSource4([]);

          const data: any = await fnGetDataSet(param);
          if (selectedTabPage.current === "1") {
            setDataSource1(data[0]);
            setDataSource2(data[1] || []);

            if (data[0] && data[0].length > 0) {
              await new Promise((resolve) => setTimeout(resolve, 50));

              setGridFocus(true);
            }
          } else {
            setDataSource3(data[2] || []);
            setDataSource4(data[3] || []);

            if (data[2] && data[2].length > 0) {
              await new Promise((resolve) => setTimeout(resolve, 50));

              setGridFocus(true);
            }
          }

          gridRef1.current?.resetUpdate();
          gridRef2.current?.resetUpdate();
          gridRef3.current?.resetUpdate();
          gridRef4.current?.resetUpdate();
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchdatasource();
    };
    //#endregion

    //#region Event Method
    const onTabChanged = (index: string) => {
      selectedTabPage.current = index;
      onSearch();
    };

    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event;
      if (selectedRow) {
        const no_po = selectedRow.no_po;
        gridRef2.current.applyFilters({ no_po: no_po });
      } else {
        return;
      }
    };

    const onFocusedRowChanged2 = (event: any) => {
      const selectedRow = event;
      if (selectedRow) {
        const cd_cust = selectedRow.cd_cust;
        const cd_exch = selectedRow.cd_exch;
        const fg_trns = selectedRow.fg_trns;
        const fg_money = selectedRow.fg_money;
        const cd_po = selectedRow.cd_po;
        const fg_po = selectedRow.fg_po;

        gridRef4.current?.applyFilters({
          cd_cust: cd_cust,
          cd_exch: cd_exch,
          fg_trns: fg_trns,
          fg_money: fg_money,
          cd_po: cd_po,
          fg_po: fg_po,
        });
      } else {
        return;
      }
    };

    const onCellValueChangedH = (event: any) => {
      if (!event) return;

      if (isSyncingCheckbox.current) return;

      const updatedRow = event.data;
      const updatedColumnId = event.column.getColId();

      if (updatedColumnId !== "fixCheckbox") return;

      const isChecked = updatedRow.fixCheckbox;
      const { no_po } = updatedRow;

      const isParentGrid =
        gridRef1.current.api.getRowNode(event.node.id) !== undefined;

      isSyncingCheckbox.current = true;

      if (isParentGrid) {
        gridRef2.current.api.forEachNodeAfterFilter((node: any) => {
          node.setDataValue("fixCheckbox", isChecked);
        });
      } else {
        const matchingChildren: any[] = [];
        gridRef2.current.api.forEachNodeAfterFilter((node: any) => {
          const child = node.data;
          matchingChildren.push(child);
        });

        const anyChecked = matchingChildren.some((row) => row.fixCheckbox);
        gridRef1.current.api.forEachNode((node: any) => {
          const parent = node.data;
          if (parent.no_po === no_po) {
            node.setDataValue("fixCheckbox", anyChecked);
          }
        });
      }

      setTimeout(() => {
        isSyncingCheckbox.current = false;
      }, 0);
    };

    const onCellValueChangedL = (event: any) => {
      if (!event) return;

      if (isSyncingCheckbox.current) return;

      const updatedRow = event.data;
      const updatedColumnId = event.column.getColId();

      if (updatedColumnId !== "fixCheckbox") return;

      const isChecked = updatedRow.fixCheckbox;
      const { cd_cust, cd_exch, fg_trns, fg_money, cd_po, fg_po } = updatedRow;

      const isParentGrid =
        gridRef3.current.api.getRowNode(event.node.id) !== undefined;

      isSyncingCheckbox.current = true;

      if (isParentGrid) {
        gridRef4.current?.api.forEachNodeAfterFilter((node: any) => {
          node.setDataValue("fixCheckbox", isChecked);
        });
      } else {
        const matchingChildren: any[] = [];
        gridRef4.current.api.forEachNodeAfterFilter((node: any) => {
          const child = node.data;
          matchingChildren.push(child);
        });

        const anyChecked = matchingChildren.some((row) => row.fixCheckbox);

        gridRef3.current.api.forEachNode((node: any) => {
          const parent = node.data;
          if (
            parent.cd_cust === cd_cust &&
            parent.cd_exch === cd_exch &&
            parent.fg_trns === fg_trns &&
            parent.fg_money === fg_money &&
            parent.cd_po === cd_po &&
            parent.fg_po === fg_po
          ) {
            node.setDataValue("fixCheckbox", anyChecked);
          }
        });
      }

      setTimeout(() => {
        isSyncingCheckbox.current = false;
      }, 0);
    };
    //#endregion

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          ></SearchPanel>
        </div>

        <div style={{ textAlign: "center" }}>
          <SnSearchBtn
            text={"조회"}
            onClick={onSearch}
            sx={{ width: 80, marginTop: 1.5 }}
            spinner={true}
          />
        </div>

        <SnTab
          titles={["발주번호별", "고객사별"]}
          width={"100%"}
          onTabChanged={onTabChanged}
          body={[
            <div className="h-full" key="grid">
              <div style={{ height: "24vh" }}>
                <SnGrid
                  ref={gridRef1}
                  columnConfig={columns1}
                  rowData={dataSource1}
                  rowSelection="single"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                  onFocusedRowChanged={onFocusedRowChanged}
                  onCellValueChanged={onCellValueChangedH}
                />
              </div>
              <div style={{ height: "25vh", marginTop: "10px" }}>
                <SnGrid
                  ref={gridRef2}
                  columnConfig={columns2}
                  rowData={dataSource2}
                  rowSelection="multiple"
                  isEditable={false}
                  enableAddRow={false}
                  ischeckboxSelection={true}
                  onCellValueChanged={onCellValueChangedH}
                />
              </div>
            </div>,

            <div className="h-full" key="grid">
              <div style={{ height: "24vh" }}>
                <SnGrid
                  ref={gridRef3} // Grid Name
                  columnConfig={columns3} // 컬럼 설정 전달
                  rowData={dataSource3} // DataSource
                  rowSelection="single" // 행 선택 모드(단일)
                  isEditable={false} // 수정 가능 여부
                  enableAddRow={false} // 행 추가 여부
                  ischeckboxSelection={true} // 체크박스 유무
                  onFocusedRowChanged={onFocusedRowChanged2} // focus 시 필터링하는 이벤트
                  onCellValueChanged={onCellValueChangedL}
                />
              </div>
              <div style={{ height: "25vh", marginTop: "10px" }}>
                <SnGrid
                  ref={gridRef4} // Grid Name
                  columnConfig={columns4} // 컬럼 설정 전달
                  rowData={dataSource4} // DataSource
                  rowSelection="multiple" // 행 선택 모드(멀티)
                  isEditable={false} // 수정 가능 여부
                  enableAddRow={false} // 행 추가 여부
                  ischeckboxSelection={true} // 체크박스 유무
                  onCellValueChanged={onCellValueChangedL}
                />
              </div>
            </div>,
          ]}
        />
      </div>
    );
  }
);

export default SN_PUR_RCV_REG_001_POP_001;
